export const en = {
  "app.name": "Market Maker",
  "language.label": "Language",
  "language.english": "English",
  "language.thai": "Thai",
  "common.loading": "Loading…",
  "common.loadingAccounts": "Loading accounts…",
  "common.loadingInstruments": "Loading instruments…",
  "common.create": "Create",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.continue": "Continue",
  "common.back": "Back",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.clear": "Clear",
  "common.loadMore": "Load more",
  "common.prev": "Prev",
  "common.next": "Next",
  "common.status": "Status",
  "common.updated": "Updated",
  "common.actions": "Actions",
  "common.user": "User",
  "common.market": "Market",
  "common.order": "Order",
  "common.trade": "Trade",
  "common.price": "Price",
  "common.quantity": "Quantity",
  "common.outcome": "Outcome",
  "common.side": "Side",
  "common.account": "Account",
  "common.available": "Available",
  "common.search": "Search",
  "common.yes": "Yes",
  "common.no": "No",
  "common.default": "default",
  "common.directMarket": "Direct market",
  "status.RUNNING": "Running",
  "status.PAUSING": "Pausing",
  "status.PAUSED": "Paused",
  "status.RESUMING": "Resuming",
  "status.STOPPING": "Stopping",
  "status.STOPPED": "Stopped",
  "status.FAILED": "Failed",
  "status.PENDING": "Pending",
  "status.ACTIVE": "Active",
  "status.INACTIVE": "Inactive",
  "status.SUSPENDED": "Suspended",
  "status.CLOSED": "Closed",
  "status.OPEN": "Open",
  "status.ORDER_CREATED": "Order created",
  "status.SENT_TO_ENGINE": "Sent to engine",
  "status.FILLED": "Filled",
  "status.PARTIALLY_FILLED": "Partially filled",
  "status.REJECTED": "Rejected",
  "status.CANCELED": "Canceled",
  "status.EXPIRED": "Expired",
  "status.CANCEL_PENDING": "Cancel pending",
  "status.PENDING_ENGINE": "Pending engine",
  "status.RESERVED": "Reserved",
  "reason.MANUAL": "Manual stop",
  "reason.SCHEDULED": "Scheduled stop",
  "reason.BUDGET": "Budget limit",
  "reason.FAILURE": "Failure",
  "reason.SHUTDOWN": "Service shutdown",
  "event.STARTED": "Started",
  "event.STOP_REQUESTED": "Stop requested",
  "event.STOPPED": "Stopped",
  "event.FAILED": "Failed",
  "event.BUDGET_PAUSED": "Budget paused",
  "event.BUDGET_RESUMED": "Budget resumed",
  "event.INSTRUMENT_ADDED": "Instrument added",
  "event.INSTRUMENT_REMOVED": "Instrument removed",
  "event.PLACE_OK": "Order placed",
  "event.PLACE_FAIL": "Order placement failed",
  "event.CANCEL_OK": "Order canceled",
  "event.CANCEL_FAIL": "Order cancellation failed",
  "event.FILL": "Order filled",
  "event.NOTE": "Note",
  "event.FUNDING_INSUFFICIENT": "Insufficient funding",
  "budgetSource.tracker": "Live tracker",
  "budgetSource.repo": "Stored snapshot",
  "paramKind.int": "whole number",
  "paramKind.int64": "whole number",
  "paramKind.percent": "percent",
  "paramKind.bps": "%",
  "paramKind.bool": "yes/no",
  "paramKind.duration_ms": "milliseconds",
  "paramKind.ticks": "price ticks",
  "paramKind.price": "price",
  "paramKind.string": "text",
  "trading.buy": "BUY",
  "trading.sell": "SELL",
  "trading.yes": "YES",
  "trading.no": "NO",
  "nav.operate": "Operate",
  "nav.library": "Library",
  "nav.overview": "Overview",
  "nav.runs": "Runs",
  "nav.accounts": "Accounts",
  "nav.presets": "Presets",
  "nav.strategies": "Strategies",
  "nav.instruments": "Instruments",
  "nav.version": "Admin · v0.1",
  "nav.aria": "Market-maker navigation",
  "topbar.openNavigation": "Open navigation",
  "topbar.signOut": "Sign out",
  "topbar.signingOut": "Signing out…",
  "login.operatorConsole": "Operator console",
  "login.brand": "Market Maker · Operator console",
  "login.signIn": "Sign in",
  "login.subtitle": "Use the same admin email you use for the Smart Market backoffice.",
  "login.email": "Email",
  "login.password": "Password",
  "login.continue": "Continue",
  "login.signingIn": "Signing in",
  "login.twoFactor": "Two-factor",
  "login.enterCode": "Enter your code",
  "login.codeInstruction": "Open your authenticator for {email} and enter the 6-digit code.",
  "login.digitAria": "Digit {digit} of 6",
  "login.verify": "Verify & sign in",
  "login.verifying": "Verifying",
  "login.back": "← Back to password",
  "login.error.codeRejected": "Code rejected. Check your authenticator and try again.",
  "login.error.credentials": "Email or password is incorrect.",
  "login.error.rateLimit": "Too many attempts. Wait a moment before trying again.",
  "login.error.unreachable": "Backoffice is unreachable. Check the cluster and retry.",
  "login.error.verify": "Verification failed.",
  "login.error.signIn": "Sign-in failed.",
  "login.error.noFactor": "Two-factor is required, but no active factor is enrolled. Ask a SUPER_ADMIN to enroll one.",
  "overview.subtitle": "Control the liquidity fleet — start, stop, and supervise runs.",
  "overview.defaultPreset": "Default preset",
  "overview.strategyMakers": "Strategy {strategy} · {makers} makers",
  "overview.takers": ", {count} takers",
  "overview.noDefault": "No default configured.",
  "overview.authorOne": "Author one",
  "overview.orSetDefault": "or set an existing preset as default.",
  "overview.activeRuns": "Active runs",
  "overview.fleetIdle": "Fleet idle. Start a run from the Runs page.",
  "overview.runsDriving": "{count} run(s) driving liquidity.",
  "overview.quickActions": "Quick actions",
  "overview.viewRuns": "View all runs →",
  "overview.editPresets": "Edit presets →",
  "overview.browseStrategies": "Browse strategies →",
  "overview.recentRuns": "Recent runs",
  "overview.viewAll": "View all",
  "overview.noRuns": "No runs yet. Start one from the Runs page.",
  "overview.runId": "Run ID",
  "overview.strategy": "Strategy",
  "overview.started": "Started",
  "overview.stopped": "Stopped",
  "accounts.title": "MM accounts",
  "accounts.subtitle": "Accounts with the MARKET_MAKER role. Select them in a preset to choose which user executes the bot.",
  "accounts.name": "Account name",
  "accounts.namePlaceholder": "Summer Campaign 2026",
  "accounts.codeSuffix": "Code suffix",
  "accounts.fullCode": "Full code: SYSTEM_MM.{suffix}",
  "accounts.codeHint": "Uppercase letters, digits, _ . - only.",
  "accounts.purpose": "Purpose (optional)",
  "accounts.purposePlaceholder": "budget for the summer promo push",
  "accounts.initialFunding": "Initial funding",
  "accounts.selectable": "Selectable accounts",
  "accounts.count": "{count} accounts",
  "accounts.searchPlaceholder": "email, name, or user id",
  "accounts.bot": "Bot",
  "accounts.platformFee": "Platform fee",
  "accounts.userId": "User ID",
  "accounts.brokerAccount": "Broker account",
  "accounts.brokerId": "Broker",
  "accounts.brokerAccountMismatch": "This balance was read for a different broker account than the one shown. Refresh before moving money.",
  "accounts.unnamed": "Unnamed MM",
  "accounts.unknownStrategy": "unknown strategy",
  "accounts.run": "run {id}…",
  "accounts.idle": "Idle",
  "accounts.noMatch": "No market-maker accounts match this search.",
  "accounts.editFee": "Edit platform fee",
  "accounts.makerFee": "Maker fee %",
  "accounts.takerFee": "Taker fee %",
  "accounts.feeSummary": "Maker {maker}% / Taker {taker}%",
  "accounts.error.create": "Create failed.",
  "accounts.error.updateFees": "Update fees failed.",
  // SM-342: execution wallet vs funding reserve. Two owners, never
  // summed — the labels have to make that obvious at a glance.
  "accounts.executionAvailable": "Execution available",
  "accounts.executionReserved": "Reserved",
  "accounts.executionReservedHint": "Held by open orders",
  "accounts.fundingReserve": "Funding reserve",
  "accounts.fundingReserveHint": "Transfer to the execution wallet before it can trade",
  "accounts.linkUnlinked": "Not linked",
  "accounts.linkUnlinkedHint": "No funding reserve is linked to this account. Ask an operator to run the funding-link backfill, or map its SYSTEM_MM child in Backoffice.",
  "accounts.linkInvalid": "Invalid mapping",
  "accounts.linkInvalidHint": "The linked reserve is missing or unusable. Check the SYSTEM_MM child in Backoffice Treasury.",
  "accounts.balanceUnavailable": "Unavailable",
  "accounts.balanceUnavailableHint": "Couldn't read this balance — it is not necessarily zero.",
  // Transfer between MM accounts (SM-380). "Execution" is load-bearing
  // in every string here: this moves the tradable wallet balance, never
  // the funding reserve shown in the column beside it.
  "accounts.transfer.open": "Transfer between accounts",
  "accounts.transfer.title": "Transfer execution balance",
  "accounts.transfer.subtitle": "Move available execution balance from one MM account to another. Funding reserves are not touched.",
  "accounts.transfer.from": "From",
  "accounts.transfer.to": "To",
  "accounts.transfer.pick": "Pick a {side} account",
  "accounts.transfer.amount": "Amount",
  "accounts.transfer.amountHint": "Execution available: {available}",
  "accounts.transfer.amountNoSource": "Pick a source account to see what is available.",
  "accounts.transfer.max": "Max",
  "accounts.transfer.insufficient": "More than the source has available.",
  "accounts.transfer.reason": "Reason",
  "accounts.transfer.reasonPlaceholder": "rebalancing ahead of the evening session",
  "accounts.transfer.reasonHint": "Recorded on both accounts' ledger history.",
  "accounts.transfer.sameAccount": "Source and destination must be different accounts.",
  "accounts.transfer.reservedNotTransferable": "not transferable",
  "accounts.transfer.onActiveRun": "Running a bot",
  "accounts.transfer.activeRunWarning": "One of these accounts is running a bot. The run keeps going, but moving available balance changes how much it can quote.",
  "accounts.transfer.noEligible": "No eligible accounts. An account needs a readable execution balance to take part in a transfer.",
  "accounts.transfer.confirm": "Transfer",
  "accounts.transfer.afterSource": "Source after transfer",
  "accounts.transfer.afterDestination": "Destination after transfer",
  "accounts.transfer.estimateHint": "Estimates. Open orders may settle before the transfer lands.",
  "accounts.transfer.error": "The transfer did not go through.",
  "accounts.transfer.done": "Transfer complete. Both balances have been refreshed.",
  "accounts.transfer.crossBroker": "These two accounts belong to different brokers; a transfer cannot cross brokers.",
  "accounts.transfer.refreshAccounts": "Refresh accounts",
  "accounts.transfer.refreshHint": "Refreshing returns you to the form. Check both accounts, then continue to confirm a new transfer.",
  // Return one MM execution wallet to its own linked SYSTEM_MM reserve.
  "accounts.return.open": "Return to reserve",
  "accounts.return.openHint": "Move available execution funds back to this account's linked reserve.",
  "accounts.return.title": "Return execution funds",
  "accounts.return.subtitle": "Move available execution funds from {account} back to its linked SYSTEM_MM reserve.",
  "accounts.return.executionAccount": "Execution account",
  "accounts.return.destination": "Linked reserve",
  "accounts.return.noReserve": "No linked reserve",
  "accounts.return.amount": "Amount",
  "accounts.return.amountHint": "Execution available: {available}",
  "accounts.return.balanceUnavailable": "The execution balance is unavailable. Refresh before returning funds.",
  "accounts.return.max": "Max",
  "accounts.return.insufficient": "More than this execution wallet has available.",
  "accounts.return.reason": "Reason",
  "accounts.return.reasonPlaceholder": "return unused budget after the run",
  "accounts.return.reasonHint": "Required and recorded in the audit trail.",
  "accounts.return.activeRunWarning": "This account is running a bot. The run keeps going, but returning funds reduces how much it can quote.",
  "accounts.return.linkUnavailable": "A valid linked SYSTEM_MM reserve is required.",
  "accounts.return.empty": "There is no available execution balance to return.",
  "accounts.return.executionAfter": "Execution after return",
  "accounts.return.reserveAfter": "Reserve after return",
  "accounts.return.confirmHint": "Only available execution balance moves. Funds reserved for open orders stay in the execution wallet.",
  "accounts.return.confirm": "Return to reserve",
  "accounts.return.error": "The execution funds were not returned.",
  "accounts.return.done": "Execution funds returned. The execution and reserve balances have been refreshed.",
  // Which currency wallets the reserve holds, and repairing the ones
  // it does not (SM-526). Whole sentences: a fragment assembled around
  // a placeholder cannot be reordered into Thai.
  // SM-570 — the funding reserve reads one row per currency. "Not
  // provisioned" and "Unavailable" are deliberately different words:
  // the first is a wallet nobody created (Repair fixes it), the second
  // is a wallet whose balance could not be read (nothing to fix here).
  "accounts.reserveBalances.aria": "Funding reserve balance by currency",
  "accounts.reserveBalances.notProvisioned": "Not provisioned",
  "accounts.reserveBalances.notProvisionedHint": "This reserve has no {currency} wallet, so it holds no {currency} at all — this is not a zero balance.",
  "accounts.reserveBalances.dialogTitle": "Reserve balances",
  "accounts.reserveBalances.dialogHint": "Only the selected currency is moved and only its balance is checked.",
  "accounts.reserveCurrency.presentHint": "This reserve has a {currency} wallet.",
  "accounts.reserveCurrency.repair": "Add missing wallets",
  "accounts.reserveCurrency.repairHint": "Create this reserve's missing {currencies} wallet. It starts empty — no money moves — and a GAME run cannot use the reserve until it exists.",
  "accounts.reserveCurrency.repairing": "Adding wallet…",
  "accounts.reserveCurrency.repaired": "Reserve currencies repaired: {provisioned} wallet(s) created, each starting empty.",
  "accounts.reserveCurrency.repairedWithFailures": "Reserve currencies partly repaired: {provisioned} wallet(s) created, {missing} still missing. Check that the parent SYSTEM_MM pool has a wallet in that currency.",
  "accounts.reserveCurrency.error": "The reserve's missing currency wallets were not created.",
  // Actions whose source is the linked SYSTEM_MM child reserve.
  "accounts.reserve.fundOpen": "Fund execution",
  "accounts.reserve.parentOpen": "Move to parent",
  "accounts.reserve.fundOpenHint": "Move this reserve into the linked execution wallet.",
  "accounts.reserve.parentOpenHint": "Move this child reserve back to parent SYSTEM_MM.",
  "accounts.reserve.linkUnavailable": "A valid linked SYSTEM_MM reserve is required.",
  "accounts.reserve.balanceUnavailable": "The funding reserve is unavailable. Refresh before moving funds.",
  "accounts.reserve.empty": "There is no available funding reserve to move.",
  "accounts.reserve.fundTitle": "Fund execution wallet",
  "accounts.reserve.parentTitle": "Move reserve to parent",
  "accounts.reserve.fundSubtitle": "Move available reserve into {account}'s linked execution wallet.",
  "accounts.reserve.parentSubtitle": "Move available reserve from {account}'s child account back to parent SYSTEM_MM.",
  "accounts.reserve.source": "Funding reserve",
  "accounts.reserve.destination": "Destination",
  "accounts.reserve.executionDestination": "{account} execution wallet",
  "accounts.reserve.amount": "Amount",
  "accounts.reserve.amountHint": "Funding reserve available: {available}",
  "accounts.reserve.insufficient": "More than this funding reserve has available.",
  "accounts.reserve.max": "Max",
  "accounts.reserve.reason": "Reason",
  "accounts.reserve.fundReasonPlaceholder": "fund execution for the next session",
  "accounts.reserve.parentReasonPlaceholder": "return unused reserve to the parent pool",
  "accounts.reserve.reasonHint": "Required and recorded in the audit trail.",
  "accounts.reserve.reserveAfter": "Reserve after transfer",
  "accounts.reserve.executionAfter": "Execution after funding",
  "accounts.reserve.parentReceives": "Parent receives",
  "accounts.reserve.fundConfirmHint": "This moves available reserve into the linked execution wallet. Reserved execution funds are unchanged.",
  "accounts.reserve.parentConfirmHint": "This moves available child reserve to parent SYSTEM_MM. The execution wallet is unchanged.",
  "accounts.reserve.fundConfirm": "Fund execution",
  "accounts.reserve.parentConfirm": "Move to SYSTEM_MM",
  "accounts.reserve.fundError": "The execution wallet was not funded.",
  "accounts.reserve.parentError": "The reserve was not moved to parent SYSTEM_MM.",
  "accounts.reserve.fundDone": "Execution funded. The execution and reserve balances have been refreshed.",
  "accounts.reserve.parentDone": "Reserve moved to parent SYSTEM_MM. The child reserve has been refreshed.",
  "accounts.createdNotFunded": "Account created. Its funding reserve is linked but not yet spendable — transfer from it to the execution wallet before starting a run.",
  "presets.title": "Presets",
  "presets.subtitle": "Named templates. Each preset is a snapshot of strategy + pools + ladder + budget + schedule.",
  "presets.new": "New preset",
  "presets.startError": "Couldn't start the run.",
  "presets.emptyBefore": "No presets yet. Either",
  "presets.createOne": "create one",
  "presets.emptyAfter": "or restart the market-maker service so it seeds a default from the env block.",
  "presets.name": "Name",
  "presets.strategy": "Strategy",
  "presets.pools": "Pools",
  "presets.poolSummary": "{bid} bid / {ask} ask / {taker} taker",
  "presets.start": "Start",
  "presets.duplicate": "Duplicate",
  "presets.setDefault": "Set default",
  "presets.deleteConfirm": "Delete preset “{name}”? This is reversible — soft-delete only.",
  "preset.newTitle": "New preset",
  "preset.newBreadcrumb": "New",
  "preset.newSubtitle": "Author a RunConfig. The supervisor snapshots this at run start so later edits do not change a running fleet.",
  "preset.create": "Create preset",
  "preset.save": "Save changes",
  "preset.error.create": "Create failed.",
  "preset.error.update": "Update failed.",
  "editor.identity": "Identity",
  "editor.name": "Name",
  "editor.namePlaceholder": "e.g. polymarket-default",
  "editor.description": "Description",
  "editor.descriptionPlaceholder": "Optional context for other operators",
  "editor.strategy": "Strategy",
  "editor.strategyName": "Strategy name",
  "editor.pools": "Pools",
  "editor.inventoryMode": "Inventory mode",
  "editor.singleInventory": "Single inventory account",
  "editor.singleInventoryHint": "One maker account is shared across bid and ask routes.",
  "editor.takerMode": "Taker mode",
  "editor.enableTakers": "Enable taker accounts",
  "editor.enableTakersHint": "When enabled, choose the taker accounts that can place crossing flow.",
  "editor.maxLoss": "Max loss",
  "editor.riskBudget": "Risk budget",
  "editor.initialFunding": "Initial funding",
  "editor.executionAccounts": "Execution accounts",
  "editor.executionHint": "Leave maker empty to let bootstrap use the generated account pattern.",
  "editor.sharedMaker": "Shared maker account",
  "editor.takersSelected": "Takers ({count} selected)",
  "editor.selectTakerValidation": "Select at least one taker account before saving.",
  "editor.fairValue": "Fair value",
  "editor.initRange": "Init range %",
  "editor.drift": "Drift (bps)",
  "editor.reversion": "Reversion %",
  "editor.takerLoop": "Taker loop",
  "editor.interval": "Interval (ms)",
  "editor.ordersPerTick": "Orders / tick",
  "editor.qtyMin": "Qty min",
  "editor.qtyMax": "Qty max",
  "editor.offsetTicks": "Offset (ticks)",
  "editor.buyBias": "Buy bias %",
  "editor.quoteManagement": "Quote management",
  "editor.replenish": "Replenish partially-filled maker quotes",
  "editor.replenishThreshold": "Replenish threshold %",
  "editor.inFlightGrace": "In-flight grace (ms)",
  "editor.sellPolicy": "Sell policy",
  "editor.allowUncovered": "Allow uncovered SELL YES",
  "editor.fallback": "Fallback",
  "editor.buyOpposite": "Buy opposite outcome",
  "editor.partialInventory": "Partial inventory",
  "editor.split": "Split",
  "editor.schedule": "Schedule",
  "editor.scheduleHint": "Leave blank for “start now” / “run until stopped.” Times use your local timezone and are stored as UTC.",
  "editor.startAt": "Start at",
  "editor.endAt": "End at",
  "editor.instruments": "Instruments",
  "editor.mode": "Mode",
  "editor.allOpen": "All OPEN instruments",
  "editor.allowlist": "Allowlist (selected below)",
  "editor.event": "Event",
  "editor.market": "Market",
  "editor.id": "ID",
  "editor.noInstruments": "No OPEN instruments to choose from.",
  "editor.budgets": "Budgets",
  "editor.budgetsHint": "Hard caps per scope. 0 = unlimited. Notional is price × quantity in minor units. The global cap stops the run; per-scope caps pause only that scope.",
  "editor.scope.global": "global",
  "editor.scope.maker": "maker",
  "editor.scope.taker": "taker",
  "editor.maxOrders": "Max orders",
  "editor.maxNotional": "Max notional",
  "editor.engineCadence": "Engine cadence",
  "editor.discovery": "Discovery (ms)",
  "editor.refresh": "Refresh (ms)",
  "editor.jitter": "Jitter (ms)",
  "editor.depthLevels": "Depth levels",
  "editor.minSpread": "Min spread (ticks)",
  "editor.orderMode": "Order mode",
  "editor.orderModeInternal": "internal (direct order-service)",
  "editor.orderModeOpenApi": "openapi (HMAC via api-gateway — stubbed)",
  "editor.generatedAccount": "Generated account pattern",
  "editor.accountSelectedHint": "Selected user receives the MM role and funding at run start.",
  "editor.reserveNotReady": "This account's funding reserve has no {currencies} wallet, so it cannot run {mode}. Repair it on the Accounts page.",
  "editor.noAccounts": "No MARKET_MAKER accounts yet.",
  "editor.sparkHint": "up to 2 decimals (e.g. 100.00)",
  "instruments.title": "Instruments",
  "instruments.subtitle": "Live OPEN-rule snapshot from market-service. Pick a preset and choose which instruments its future runs will use. Active runs keep their frozen preset snapshot.",
  "instruments.preset": "Preset",
  "instruments.mode": "Mode",
  "instruments.allRules": "All OPEN rules",
  "instruments.allowlist": "Allowlist (only checked)",
  "instruments.selected": "{count} selected",
  "instruments.empty": "No OPEN instruments. Open one in the backoffice catalog before starting a run.",
  "instruments.instrument": "Instrument",
  "instruments.rule": "Rule",
  "instruments.tick": "Tick",
  "instruments.lot": "Lot",
  "instruments.priceMin": "Price min",
  "instruments.priceMax": "Price max",
  "instruments.includeAria": "Include {id}",
  "instruments.saveFailed": "Save failed: {message}",
  "strategies.title": "Strategies",
  "strategies.subtitle": "Quant catalog. Each strategy emits a complete desired ladder per refresh tick. Compose with +ghost for outer safety-net depth.",
  "strategies.composite": "Composite",
  "strategies.composes": "Composes:",
  "strategies.parameters": "Parameters",
  "strategies.default": "default {value}",
  "strategies.constantSpread.title": "Constant Spread",
  "strategies.constantSpread.description": "Symmetric ladder pinned to the instrument midpoint. Useful for a predictable cold-start footprint.",
  "strategies.midpointFollow.title": "Midpoint Follow",
  "strategies.midpointFollow.description": "Tracks the live book midpoint and falls back to the seeded fair value when the book is empty.",
  "strategies.randomWalk.title": "Random Walk",
  "strategies.randomWalk.description": "Drifts a synthetic anchor with mean reversion. Useful before a market has organic flow.",
  "strategies.ghostLadder.title": "Ghost Ladder",
  "strategies.ghostLadder.description": "Outer safety-net depth for large taker sweeps; best composed with an inner strategy.",
  "strategies.lmsrOrganicSkew.title": "LMSR Organic Skew",
  "strategies.lmsrOrganicSkew.description": "Prices from cumulative LMSR demand and blends in inventory skew using the organic share of the live book.",
  "strategies.midpointGhost.title": "Midpoint Follow + Ghost",
  "strategies.midpointGhost.description": "Midpoint Follow on inner levels and Ghost Ladder outside; the recommended production default with organic flow.",
  "strategies.randomGhost.title": "Random Walk + Ghost",
  "strategies.randomGhost.description": "Random Walk on inner levels and Ghost Ladder outside; keeps pre-launch charts moving without organic flow.",
  "strategyParam.levels": "Levels per side",
  "strategyParam.spread_ticks": "Spread (ticks)",
  "strategyParam.step_ticks": "Step (ticks)",
  "strategyParam.size_per_level": "Size per level",
  "strategyParam.size_decay_percent": "Size decay (%)",
  "strategyParam.jitter_bps": "Price jitter (bps of tick)",
  "strategyParam.size_skew_percent": "Size skew (%)",
  "strategyParam.min_spread_ticks": "Min spread (ticks)",
  "strategyParam.drift_bps": "Drift magnitude (bps of band)",
  "strategyParam.max_loss_budget": "Max loss budget",
  "strategyParam.initial_yes_probability_bps": "Initial YES probability",
  "strategyParam.bid_ask_spread_bps": "Bid/ask spread",
  "strategyParam.skew_sensitivity_bps": "Skew sensitivity",
  "strategyParam.inventory_max": "Inventory max",
  "strategyParam.price_floor_bps": "Price floor",
  "runs.title": "Runs",
  "runs.subtitle": "Every supervisor run in reverse chronological order. Active runs auto-refresh; terminal runs remain as history.",
  "runs.startFromPreset": "Start a run from a preset →",
  "runs.filter.all": "All",
  "runs.filter.running": "Running",
  "runs.filter.stopped": "Stopped",
  "runs.filter.failed": "Failed",
  "runs.emptyBefore": "No runs match this filter. Start one from the",
  "runs.presetsPage": "Presets page",
  "runs.run": "Run",
  "runs.reason": "Reason",
  "runs.presetFallback": "Preset {id}…",
  "runs.adHoc": "Ad hoc run",
  "run.strategy": "Strategy",
  "run.preset": "preset",
  "run.stop": "Stop run",
  "run.stopConfirm": "Stop this run? Open orders will be cancelled on a best-effort basis.",
  "run.error.stop": "Couldn't stop the run.",
  "run.error.reported": "The run reported an error.",
  "run.started": "Started",
  "run.requested": "requested {time}",
  "run.stopped": "Stopped",
  "run.stopReason": "reason {reason}",
  "run.operators": "Operators",
  "run.createdBy": "created by",
  "run.stoppedBy": "stopped by",
  "run.funding": "Funding",
  "run.budgets": "Budgets",
  "run.orderDistribution": "Order distribution",
  "run.liveTop": "live · top {count}",
  "run.statsInactive": "Live stats are available only while the run is active.",
  "run.activeOrders": "Active MM orders",
  "run.activeOrdersInactive": "Active MM orders are available only while the run is active.",
  "run.error.activity": "Couldn't load order activity.",
  "run.tradeHistory": "MM trade history",
  "run.tradeHistoryInactive": "MM trade history is available only while the run is active.",
  "run.error.tradeHistory": "Couldn't load MM trade history.",
  "run.eventLog": "Event log",
  "run.noEvents": "No events yet.",
  "run.snapshot": "RunConfig snapshot",
  "run.orders": "Orders",
  "run.notional": "Notional",
  "run.filled": "filled: {count}",
  "run.placeAttempts": "Place attempts",
  "run.placeOk": "Place ok",
  "run.placeFailed": "Place failed",
  "run.cancelAttempts": "Cancel attempts",
  "run.cancelOk": "Cancel ok",
  "run.cancelFailed": "Cancel failed",
  "run.placeOkShort": "Place OK",
  "run.placeFailedShort": "Place failed",
  "run.cancelOkShort": "Cancel OK",
  "run.cancelFailedShort": "Cancel failed",
  "run.buyVsSell": "Buy vs Sell",
  "run.makerVsTaker": "Maker vs Taker",
  "run.buyCount": "Buy {count}",
  "run.sellCount": "Sell {count}",
  "run.makerCount": "Maker {count}",
  "run.takerCount": "Taker {count}",
  "run.errorsByCode": "Errors by code",
  "run.topMarkets": "Top markets",
  "run.topMakers": "Top makers",
  "run.noActivity": "No activity yet.",
  "run.placed": "Placed",
  "run.updatedSince": "updated {updated} · since {since}",
  "run.noActiveOrders": "No active MM orders.",
  "run.buyBid": "Buy / Bid",
  "run.sellAsk": "Sell / Ask",
  "run.openCount": "{count} open",
  "run.noOrderSide": "No {side} orders.",
  "run.created": "Created",
  "run.filledQty": "Filled",
  "run.remaining": "Remaining",
  "run.noTrades": "No MM trades yet.",
  "run.matched": "Matched",
  "run.updatedTime": "updated {time}",
  "funding.source": "Funded from {account}",
  "funding.worstCase": "worst case · fresh wallets",
  "funding.perAccount": "Per account",
  "funding.accounts": "Accounts",
  "funding.totalRequired": "Total required",
  "funding.available": "Available",
  "funding.warning": "The funding account may not cover this run — top up {account} in backoffice Treasury. Already-funded wallets draw only their shortfall; the run-start check is authoritative.",
  "error.details": "Technical details",
  "error.generic": "Something went wrong.",
  "error.network": "Can't reach the market-maker service — check your connection and try again.",
  "error.server": "Something went wrong on the server. Please try again in a moment.",
  "nav.pools": "Conversion pools",
  "pools.title": "Conversion pools",
  "pools.intro": "GREEN converts to RED and to GOLD, and every conversion pays out of the destination currency's prefunded pool. Watch the level here and top it up or draw it down; each figure is single-currency and pools are never added together.",
  "pools.notCapital": "A conversion pool is a platform obligation to users holding GREEN — not market-maker capital. It is never part of an execution balance or a risk budget, and no strategy can consume it.",
  "pools.readFailed": "Pool liquidity could not be read. Do not act on a stale number — reload first.",
  "pools.none": "The ledger reports no source pool.",
  "pools.receiptHeading": "Receipt account",
  "pools.outflowHeading": "Recent conversion outflow",
  "pools.cardTitle": "{currency} pool",
  "pools.total": "Total",
  "pools.available": "Available",
  "pools.reserved": "Reserved",
  "pools.reservedNote": "Reserved counts active ledger operations only. An unexecuted user quote reserves nothing and is never shown here.",
  "pools.utilisation": "Utilisation",
  "pools.utilisationUnknown": "No liquidity to utilise",
  "pools.routeStatus": "Route switch",
  "pools.routeSwitchOn": "Enabled",
  "pools.routeSwitchOff": "Disabled",
  "pools.routeUnknown": "Not reported",
  "pools.payingOut": "Currently paying out",
  "pools.routeConfigElsewhere": "Rates, fees, limits and the route switch are set in Backoffice.",
  "pools.needPermission": "Needs the conversion pool-manage permission.",
  "pools.stateFunded": "Funded",
  "pools.stateLow": "Low",
  "pools.stateExhausted": "Exhausted",
  "pools.stateUnfunded": "Unfunded",
  "pools.stateReceiving": "Receiving",
  "pools.exhaustedExplain": "The pool cannot pay out. Conversions into this currency fail until it is funded.",
  "pools.lowExplain": "Available liquidity is at or below the minimum threshold. Top it up before the route runs dry.",
  "pools.unfundedExplain": "The pool has never been funded, so its route cannot pay out yet.",
  "pools.fund": "Fund",
  "pools.rebalance": "Rebalance",
  "pools.fundTitle": "Fund the {currency} pool",
  "pools.rebalanceTitle": "Rebalance the {currency} pool",
  "pools.fundSubtitle": "Moves value from the treasury into the conversion pool. Nothing is minted: the treasury is debited by exactly this amount, in the same currency.",
  "pools.rebalanceSubtitle": "Moves surplus liquidity out of the conversion pool back to the treasury. Nothing is burned.",
  "pools.currency": "Currency",
  "pools.source": "From",
  "pools.destination": "To",
  "pools.amount": "Amount",
  "pools.amountHint": "Enter an amount greater than zero.",
  "pools.wireHint": "Exact wire amount sent: {minor}",
  "pools.overdraw": "More than the pool has available. Reserved liquidity backs conversions already in flight.",
  "pools.reason": "Reason",
  "pools.reasonPlaceholder": "Why this movement is being made",
  "pools.reasonHint": "Required. It lands on the audit row beside your admin id.",
  "pools.movement": "Movement",
  "pools.reference": "Idempotency reference",
  "pools.confirm": "Confirm movement",
  "pools.movementFailed": "The movement could not be completed.",
  "pools.movementsFailed": "Movement history could not be read.",
  "pools.noMovements": "No movements on the {currency} pool yet.",
  "pools.colWhen": "When",
  "pools.colKind": "Kind",
  "pools.colAmount": "Amount",
  "pools.colRoute": "From → to",
  "pools.colReference": "Reference",
  "pools.idempotencyNote": "Rows are keyed by their idempotency reference: a replayed or double-submitted movement appears once, not twice.",
  "paramKind.money": "amount",
  "accounts.fundingCurrency": "Funding currency",
  "accounts.initialFundingHint": "In {currency}",
  "accounts.perCurrency": "Per-currency balances",
  "presets.gameSurfaceOff": "This preset trades the GAME channel, which is not enabled in this build. Ask the rollout owner to turn the GAME strategy surface on before starting it.",
  "presets.gameNoOptIn": "This preset trades the GAME channel but carries no explicit GAME opt-in, so the server will refuse it. Open the preset and opt in before starting.",
  "presets.tradingMode": "Trading mode",
  "presets.modeCash": "Cash · buys and pays GOLD",
  "presets.modeGame": "Game · buys RED, pays GREEN",
  "overview.activeCash": "Cash runs",
  "overview.activeGame": "Game runs",

  // New lifecycle audit events (SM-538).
  "event.PAUSE_REQUESTED": "Pause requested",
  "event.PAUSED": "Paused",
  "event.RESUME_REQUESTED": "Resume requested",
  "event.RESUMED": "Resumed",
  "event.RESTART_REQUESTED": "Restart requested",
  "event.RECOVERED": "Recovered from checkpoint",
  "event.SNAPSHOT_CAPTURED": "State snapshot captured",
  "event.CHECKPOINT_SAVED": "Checkpoint saved",
  "event.CHECKPOINT_RESTORED": "Checkpoint restored",
  "event.RECONCILED": "Upstream orders reconciled",
  "event.AUTO_START": "Auto-start result",

  // --- SM-538: run lifecycle, state, history, auto-start ---
  "common.retry": "Retry",
  // SM-563 — shown over rows that were already on screen when the
  // operator arrived, while this page re-reads them.
  "data.loadFailed": "Could not load current data. Please retry.",
  "data.refreshing": "Refreshing…",
  "data.staleAfterError": "This is the last data we could load — the newest refresh failed.",
  "runs.emptyStart": "No runs yet. Start a preset from the Presets page to create the first one.",
  "accounts.unknownPreset": "Unknown preset",
  "overview.autoStartPresets": "Starts after restart",
  "overview.noAutoStart": "No preset is enabled to start after a service restart.",
  "mode.cash": "Cash",
  "mode.game": "Game",

  // Run-state view. Source and completeness are stated in WORDS, never
  // by colour alone — the difference between live and historical data,
  // and between "unreadable" and "empty", has to survive a monochrome
  // display and a colour-blind reader.
  "runState.source.live": "Live",
  "runState.source.snapshot": "Snapshot",
  "runState.source.checkpoint": "Last checkpoint",
  "runState.completeness.complete": "Complete",
  "runState.completeness.partial": "Partial",
  "runState.completeness.unavailable": "Unavailable",
  "runState.completeness.notCaptured": "Not captured",
  "runState.stale": "Stale",
  "runState.capturedAt": "Captured {time}",
  "runState.unavailableBody": "This section could not be read, so it is shown as unavailable rather than as zero. Retry, or check the upstream service.",
  "runState.notCapturedBody": "No state was captured for this run, so there is nothing to show. This is not the same as the run holding nothing.",
  "runState.sectionFailed": "This section failed to load. The other sections are unaffected.",
  "runState.tab.orders": "Orders",
  "runState.tab.positions": "Positions",
  "runState.tab.trades": "Trades",
  "runState.tab.balances": "Balances",
  "runState.noPositions": "No open positions.",
  "runState.noBalances": "No wallets to show.",
  "runState.balanceUnavailable": "Unavailable",
  "runState.balanceUnavailableHint": "This wallet could not be read. It is not necessarily empty.",
  "runState.col.mode": "Mode",
  "runState.col.currency": "Currency",
  "runState.col.channel": "Channel",
  "runState.col.scope": "Scope",
  "runState.col.reserved": "Reserved",
  "runState.col.direction": "Direction",
  "runState.pageRange": "{start}-{end} of {total}",

  // Lifecycle actions. Confirmations state CONSEQUENCES: what is
  // cancelled, and what is deliberately left alone.
  "lifecycle.startRun": "Start run",
  "lifecycle.pause": "Pause run",
  "lifecycle.resume": "Resume run",
  "lifecycle.stop": "Stop run",
  "lifecycle.restartFromCheckpoint": "Restart from checkpoint",
  "lifecycle.startFresh": "Start fresh from preset",
  "lifecycle.pausing": "Pausing: gating new orders and cancelling the resting ones…",
  "lifecycle.resuming": "Resuming: reconciling upstream orders before quoting again…",
  "lifecycle.stopping": "Stopping: draining the fleet and capturing a snapshot…",
  "lifecycle.confirmPause": "Pause this run? Its {count} resting order(s) will be cancelled and no new orders will be placed. Positions and balances are left untouched, and the run keeps its accounts and budget so you can resume it.",
  "lifecycle.confirmStop": "Stop {preset} ({mode})? Its {count} resting order(s) will be cancelled, a final snapshot will be captured, and the run becomes permanent history — stopping cannot be undone. Positions and balances are left untouched.",
  "lifecycle.confirmPauseUnknown": "Pause this run? Its resting orders will be cancelled and no new orders will be placed. Positions and balances are left untouched, and the run keeps its accounts and budget so you can resume it.",
  "lifecycle.confirmStopUnknown": "Stop {preset} ({mode})? Its resting orders will be cancelled, a final snapshot will be captured, and the run becomes permanent history — stopping cannot be undone. Positions and balances are left untouched.",
  "lifecycle.confirmRestartCheckpoint": "Restart from the checkpoint captured {time}? This creates a NEW linked attempt that continues the failed run's budget and strategy state. The failed run is kept exactly as it is.",
  "lifecycle.confirmRestartFresh": "Start fresh from this preset? This creates a NEW attempt with no restored state: budgets, strategy state and order counters all start over. The failed run is kept exactly as it is.",
  "lifecycle.checkpointUnknownTime": "an unknown time",
  "lifecycle.blocked.noCheckpoint": "No checkpoint exists for this run, so it cannot be restarted from one. Start fresh from the preset instead.",
  "lifecycle.blocked.incompatibleVersion": "This run's checkpoint was written by a different build and cannot be restored. Start fresh from the preset instead.",
  "lifecycle.blocked.configChanged": "The preset changed after this run failed, so its checkpoint no longer matches. Start fresh from the preset instead.",
  "lifecycle.blocked.generic": "This run cannot be restarted from a checkpoint. Start fresh from the preset instead.",
  "lifecycle.error.pause": "Could not pause the run",
  "lifecycle.error.resume": "Could not resume the run",
  "lifecycle.error.restart": "Could not restart the run",

  // Identity. The name is primary; ids stay available and copyable.
  "identity.presetId": "Preset",
  "identity.runId": "Run",
  "identity.copyAria": "Copy {label} identifier {value}",
  "identity.resolved": "Name resolved",
  "identity.resolvedHint": "This run started before names were captured, so the preset's CURRENT name is shown.",
  "identity.fallback": "Name unavailable",
  "identity.fallbackHint": "The preset behind this run can no longer be resolved, so a stand-in label is shown.",

  // Preset detail tabs.
  "presetDetail.tab.overview": "Overview",
  "presetDetail.tab.state": "Live state",
  "presetDetail.tab.history": "Run history",
  "presetDetail.tab.config": "Configuration",
  "presetDetail.liveStateTitle": "Run state",
  "presetDetail.openRun": "Open run detail",
  "presetDetail.currentRun": "Current run",
  "presetDetail.latestRun": "Latest run",
  "presetDetail.noRunsYet": "No runs yet. Start this preset to create its first run.",
  "presetDetail.showingLatestTerminal": "This preset is idle. Showing the frozen snapshot of its last run, captured {time}.",
  "presetDetail.checkpointFreshness": "Checkpoint",
  "presetDetail.noCheckpoint": "None",
  "presetDetail.configImmutableNote": "Editing a preset changes future runs only. Every run keeps the configuration snapshot it started with, so running and historical runs are unaffected.",
  "presetDetail.error.load": "Could not load the preset",
  "presetDetail.error.history": "Could not load the run history",

  // Run history.
  "history.currentRun": "Current run",
  "history.previousAttempts": "Previous attempts",
  "history.emptyNoRuns": "No runs yet. Start this preset to create its first run.",
  "history.emptyFiltered": "No runs match {filters}.",
  "history.clearFilters": "Clear filters",
  "history.recoveryChain": "Recovery chain · {count} attempts",
  "history.attemptOf": "Attempt {attempt}, recovered from run {source}",
  "history.snapshotCaptured": "Captured",
  "history.col.run": "Run",
  "history.col.duration": "Duration",
  "history.col.operator": "Started or stopped by",
  "history.col.snapshot": "Snapshot",
  "history.durationMinutes": "{minutes} min",
  "history.durationHours": "{hours} h {minutes} min",
  "history.filter.active": "Active",
  "history.filter.paused": "Paused",
  "history.filter.mode": "Trading mode",
  "history.filter.runId": "Run ID",
  "history.filter.runIdPlaceholder": "Full or partial run ID",
  "history.filter.from": "From",
  "history.filter.to": "To",
  "history.filter.runIdSummary": "run ID containing {query}",
  "history.filter.fromSummary": "from {date}",
  "history.filter.toSummary": "to {date}",

  // Recovery context on run detail.
  "recovery.title": "Recovery",
  "recovery.attempt": "Attempt",
  "recovery.rootRun": "First attempt in this chain",
  "recovery.checkpointStage": "Checkpoint stage",
  "recovery.attemptsTitle": "All attempts",

  // Auto-start. Labelled by what it DOES — "default" answered a
  // question with only one possible answer, and a deployment can arm
  // several presets.
  "autoStart.title": "Service restart",
  "autoStart.toggleLabel": "Start automatically after service restart",
  "autoStart.toggleHelp": "Any number of presets can be enabled. Presets start independently, so one that conflicts does not stop the others.",
  "autoStart.enable": "Enable auto-start",
  "autoStart.disable": "Disable auto-start",
  "autoStart.willStart": "Starts on restart",
  "autoStart.willStartHint": "This preset starts automatically after a service restart.",
  "autoStart.error": "Could not change the auto-start setting",
  "autoStart.resultsTitle": "Last restart",
  "autoStart.bootedAt": "Service restarted {time}",
  "autoStart.outcome.STARTED": "Run created",
  "autoStart.outcome.RECOVERED": "Recovery run created",
  "autoStart.outcome.SKIPPED": "Skipped",
  "autoStart.outcome.FAILED": "Failed",
  "autoStart.resultColumn": "Restart result",
  "autoStart.resultColumnHint": "What the restart did for this preset. Recorded once and never rewritten; the run's own status is in the next column.",
  "autoStart.runStatusColumn": "Run status",
  "autoStart.runStateUnknown": "Run state could not be read",
  "autoStart.noRun": "No run",
  "presets.gameBlockedTitle": "This preset cannot be started from this console",
  "presets.gameBlockedDismiss": "Dismiss",
  "fundingConfirm.title": "Review funding before starting",
  "fundingConfirm.subtitle": "Every currency this run needs is checked on its own, against the account it is drawn from.",
  "fundingConfirm.ready": "Every required balance is covered. Starting moves only each wallet's shortfall.",
  "fundingConfirm.short": "At least one required balance is short. The start is refused before any transfer unless the runtime can cover it.",
  "fundingConfirm.planNote": "The start carries this plan's fingerprint ({plan}), so it executes exactly the rows shown here or is refused.",
  "fundingConfirm.startAnyway": "Start anyway",
  "fundingConfirm.pricing": "Pricing the run…",
  "fundingConfirm.unverified": "Some balances could not be read, so this review is incomplete. The runtime checks every balance again before any transfer.",
  "funding.reserveUnknown": "Unverified",
  "funding.afterStart": "After start",
  "funding.topUp": "Top-up",
  "capabilities.title": "Effective capabilities",
  "capabilities.subtitle": "What the market-maker runtime loaded, beside this console's build.",
  "capabilities.gameRuntime": "GAME trading (runtime)",
  "capabilities.gameConsole": "GAME surface (this console)",
  "capabilities.autoTopUp": "Auto top-up from the pool",
  "capabilities.autoTopUpCeiling": "Top-up ceiling",
  "capabilities.noCeiling": "No ceiling",
  "capabilities.fundingMode": "Funding mode",
  "capabilities.maxRuns": "Concurrent run cap",
  "capabilities.on": "On",
  "capabilities.off": "Off",
  "capabilities.drift": "This console and the runtime disagree about GAME. A GAME preset is refused by whichever half is off.",
  "capabilities.unavailable": "The runtime did not report its capabilities (older server).",

  // Overview facts.
  "overview.mode": "Trading mode",
  "overview.currencies": "Currencies",
  "overview.currencyPair": "Buys {debit} · pays {payout}",
  "overview.totalRuns": "Runs",
  "overview.failedRuns": "Failed runs",
  "overview.lastStarted": "Last started",
  "overview.updatedBy": "{time} by {who}",

  // Run detail additions.
  "run.stateTitle": "Run state",
  "run.openPreset": "Open preset",
  "run.lifecycleTimes": "Lifecycle",
  "run.pausedAt": "Paused",
  "run.resumedAt": "Resumed",

  // --- SM-525: dual-mode execution -------------------------------------
  "mode.all": "All",
  "mode.filterAria": "Filter by trading mode",
  "mode.currencyHint": "Buys with {debit}, pays out in {payout}.",
  "mode.debits": "Buys with",
  "mode.pays": "pays",
  "mode.column": "Mode",
  "mode.presetIs": "This preset runs in {mode} mode.",
  "mode.presetLocked": "A preset has one trading mode and cannot mix instruments from both. To run both channels on this account, create a second preset in the other mode and start it as its own run.",
  "mode.gameOptIn": "I authorise this preset to trade the GAME channel with RED and GREEN.",
  "mode.gameOptInHint": "Required before a Game preset can be saved or started. Game participation is never inherited — a copy of a Game preset asks again.",
  "mode.gameSurfaceOff": "Game mode is not enabled in this build, so a Game preset cannot be started from this console.",
  "mode.changeWarning": "Switching mode clears the instrument selection: the markets eligible in {from} mode are not the same set as in {to} mode.",
  "instruments.presetMode": "Preset mode",
  "instruments.modeTagAria": "Trading mode",
  "instruments.selectAllCash": "Select all Cash markets",
  "instruments.selectAllGame": "Select all Game markets",
  "instruments.clearSelection": "Clear selection",
  "instruments.snapshotNote": "Selecting in bulk saves the markets listed right now. Markets published later are not added to this preset on their own — bulk-select again to pick them up.",
  "instruments.ineligible": "Not available in {mode} mode",
  "instruments.eligibleCount": "{count} selectable in {mode} mode",
  "instruments.noneForMode": "No markets are currently tradable in {mode} mode. Enable the Game channel on a market in the backoffice catalog, then reload.",
  "instruments.excludedNote": "{count} market(s) in this list cannot be selected in {mode} mode and were left out.",
  "runs.filter.modeAria": "Filter runs by trading mode",
  "runs.concurrentNote": "One account can run Cash and Game at the same time. They appear as separate rows and stop independently.",
  "presets.modeColumn": "Mode",
  "editor.tradingModeTitle": "Trading mode",
  "editor.tradingModeHint": "A preset runs in exactly one mode. Cash buys with GOLD and pays GOLD; Game buys with RED and pays GREEN. There is no combined mode — run both by starting two presets.",
  "editor.selectAllForMode": "Select all {mode} markets",
  "funding.requirementsTitle": "Required balances",
  "funding.purposeExecution": "Wallet funding",
  "funding.purposeRewards": "Reward pool",
  "funding.required": "Required",
  "funding.availableUnknown": "Could not be read",
  "funding.perCurrencyNote": "Each currency is checked on its own. A surplus in one is never cover for a shortfall in another.",

  // --- SM-506: per-reserve funding -------------------------------------
  "funding.poolDraw": "From the pool",
  "funding.reservesTitle": "Maker reserves",
  "funding.reservesNote": "Each maker draws on its own reserve. Treasury balances do not roll down from the pool, so a healthy pool is not cover for an empty reserve.",
  "funding.reserveOk": "Funded",
  "funding.reserveTopUp": "Auto top-up",
  "funding.reserveBlocked": "Short",
  "funding.shortfall": "Short by",

  // --- SM-564: account detail -------------------------------------------
  "accounts.openDetail": "Open this account",
  "accounts.currency.label": "Currency",
  "accounts.currency.aria": "Currency the funds move in",
  "accounts.currency.hint": "Both wallets move in this one currency. Nothing is converted.",
  "accounts.currency.reserveMissing": "This reserve has no {currency} wallet yet. Repair the reserve currencies from the accounts list before moving {currency}.",
  "accountDetail.notFound": "No market-maker account with this id",
  "accountDetail.notFoundHint": "It may have been removed, or the link may be stale. Nothing on this page has been changed.",
  "accountDetail.backToList": "Back to accounts",
  "accountDetail.tabsAria": "Account sections",
  "accountDetail.tab.trading": "Trading",
  "accountDetail.tab.balances": "Balances",
  "accountDetail.tab.runs": "Runs",
  "accountDetail.section.orders": "Active orders",
  "accountDetail.section.positions": "Positions",
  "accountDetail.section.history": "Order history",
  "accountDetail.section.trades": "Trades",
  "accountDetail.currencyFilterAria": "Filter by currency",
  "accountDetail.allCurrencies": "All",
  "accountDetail.currencyNote": "Every amount is shown in the currency of its own record. Currencies are never added together; the filter narrows to the book that trades in the selected currency.",
  "accountDetail.header.status": "Account status",
  "accountDetail.header.reserve": "Funding reserve",
  "accountDetail.header.activeRuns": "Active runs",
  "accountDetail.col.occurred": "Occurred",
  "accountDetail.col.reason": "Reason",
  "accountDetail.col.direction": "Direction",
  "accountDetail.col.amount": "Amount",
  "accountDetail.col.kind": "Type",
  "accountDetail.col.route": "From → to",
  "accountDetail.col.txId": "Transaction",
  "accountDetail.col.reserveAvailable": "Reserve available",
  "accountDetail.col.reserveWallet": "Reserve wallet",
  "accountDetail.col.role": "Role",
  "accountDetail.col.preset": "Preset",
  "accountDetail.col.started": "Started",
  "accountDetail.col.stopped": "Stopped",
  "accountDetail.noOrders": "No resting orders for this account.",
  "accountDetail.noPositions": "No open positions for this account.",
  "accountDetail.noHistory": "No order history for this account.",
  "accountDetail.noTrades": "No trades for this account.",
  "accountDetail.noMovements": "No {currency} balance movements yet.",
  "accountDetail.noRuns": "No runs have used this account.",
  "accountDetail.balances.title": "Wallets",
  "accountDetail.balances.historyTitle": "Balance movements",
  "accountDetail.balances.historyCurrency": "Journal currency",
  "accountDetail.balances.readOnly": "You can inspect balances and history here, but your role does not allow moving funds.",
  "accountDetail.balances.provisioned": "Provisioned",
  "accountDetail.balances.notProvisioned": "No wallet",
  "accountDetail.movement.credit": "Credit",
  "accountDetail.movement.debit": "Debit",
  "accountDetail.movement.hold": "Hold",
  "accountDetail.runs.filter.all": "All",
  "accountDetail.runs.filter.active": "Active",
  "accountDetail.runs.filter.history": "History",
  "accountDetail.runs.role.maker": "Maker",
  "accountDetail.runs.role.taker": "Taker",
  "accountDetail.runs.role.selected": "Selected",
} as const;

export type TranslationKey = keyof typeof en;
